import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import auth from './modules/auth'
import project from './modules/project'
import opening from './modules/opening'
import usermanagement from './modules/usermanagement'
// import achievement from './modules/achievement'
// import auth from './modules/auth'

Vue.use(Vuex)

const state = {
  crumbs: [
    {
      title: 'Home',
      to: '/'
    }
  ],
  isLoading: false
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    project,
    auth,
    opening,
    usermanagement
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js